import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Train, Truck, Users, Clock } from 'lucide-react';
import './Home.css';

const Home = () => {
  const services = [
    {
      icon: <Train size={40} />,
      title: 'Passenger Rail Services',
      description: 'Three flagship routes: The Cruiser, The Libertarian, and The Southsidean, connecting Virginia to Norfolk, New York, and Miami.'
    },
    {
      icon: <Truck size={40} />,
      title: 'Intermodal Freight',
      description: 'Efficient freight transport solutions, managing private cargo and short lines for major companies across our network.'
    },
    {
      icon: <Users size={40} />,
      title: 'Thru-Way Connections',
      description: 'Complimentary bus service connecting passengers to stations and providing backup transportation during service interruptions.'
    },
    {
      icon: <Clock size={40} />,
      title: 'Reliable Scheduling',
      description: 'Separate mainline operations ensure punctual arrivals and departures, maximizing passenger satisfaction.'
    }
  ];

  const routes = [
    { name: 'The Cruiser', route: 'Danville ↔ Norfolk', trains: 'P058 & P158' },
    { name: 'The Libertarian', route: 'Danville ↔ NY Penn', trains: 'P301 & P295' },
    { name: 'The Southsidean', route: 'Danville ↔ Miami', trains: 'P121 & P117' }
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        {/* Hero Locomotive Image */}
        <div className="hero-locomotive-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_western-rail-hub/artifacts/lynqfdxe_ChatGPT%20Image%20May%2024%2C%202026%2C%2011_56_20%20PM.png"
            alt="AG&WESTERN Locomotive 7256"
            className="hero-locomotive-image"
          />
        </div>

        <div className="hero-content">
          <h1 className="hero-title">
            Transportation<br />Solutions for<br />Modern America
          </h1>
          <p className="hero-tagline">RELAX. EXPLORE. LIVE.</p>
          <p className="hero-description">
            AG&WESTERN Rail Inc. delivers efficient freight and passenger rail services,
            connecting communities and businesses across the Eastern United States.
          </p>
          <div className="hero-buttons">
            <Link to="/about" className="btn btn-primary">
              Learn More
            </Link>
            <Link to="/contact" className="btn btn-secondary">
              Get in Touch
            </Link>
          </div>
        </div>
      </section>

      {/* Routes Section */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <h2>Our Passenger Routes</h2>
            <p>Connecting communities across the East Coast with reliable service</p>
          </div>
          <div className="routes-grid">
            {routes.map((route) => (
              <div key={route.name} className="route-card">
                <h3>{route.name}</h3>
                <p className="route-path">{route.route}</p>
                <p className="route-trains">{route.trains}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="section section-gray">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <p>Comprehensive rail solutions for freight and passenger transportation</p>
          </div>
          <div className="services-grid">
            {services.map((service) => (
              <div key={service.title} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="section section-dark">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h2 className="stat-number">3</h2>
              <p className="stat-label">Passenger Routes</p>
            </div>
            <div className="stat-item">
              <h2 className="stat-number">24/7</h2>
              <p className="stat-label">Customer Support</p>
            </div>
            <div className="stat-item">
              <h2 className="stat-number">Free</h2>
              <p className="stat-label">Thru-Way Bus Service</p>
            </div>
            <div className="stat-item">
              <h2 className="stat-number">2025</h2>
              <p className="stat-label">Founded Dec 23</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Experience Reliable Rail Travel?</h2>
            <p>Join passengers who trust AG&WESTERN for their transportation needs across the Eastern United States.</p>
            <Link to="/contact" className="btn btn-primary">
              Contact Us Today <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;